import React, { useEffect } from "react";
import { Switch, Route, useRouteMatch } from "react-router-dom";
import { useDispatch } from "react-redux";

// redux
import { setCurrentQueue } from "../../slices/currentQueueSlice";

// data
import { QUEUES } from "../../constants";

// components
import PhotoModQueuePageContent from "../../components/PhotoModQueuePageContent";

const VisualQueuePage = () => {
    const { path } = useRouteMatch();
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(setCurrentQueue(QUEUES.VIS_MOD));
    }, []);

    return (
        <Switch>
            <Route path={path} exact>
                <PhotoModQueuePageContent />
            </Route>
            <Route path={`${path}/:filter`}>
                <PhotoModQueuePageContent />
            </Route>
        </Switch>
    );
};

export default VisualQueuePage;
